import React from 'react';
import { Token } from 'src/common/api/use-integrations.hook';
import { useNotificationMessage } from 'src/common/notification/message.hook';
import GooglePicker from 'src/integrations/GooglePicker';
import { GoogleDriveIntegrationIcon } from 'src/monet/icons';
import { openNewOauthPopup } from 'src/utils/open-new-outh-popup';

interface Props {
  tokens?: Token[];
  onFetchTokens: () => void;
  onPickFile: (data: { embedUrl: string; name: string }) => void;
}

export const DashboardLibraryContentConnectDrive = ({ onFetchTokens, onPickFile, tokens = [] }: Props) => {
  const { setErrorNotification } = useNotificationMessage();
  const receiveMessage = (event: MessageEvent<unknown>) => {
    // Do we trust the sender of this message? (might be
    // different from what we originally opened, for example).
    const { data, isTrusted } = event;

    if (isTrusted && data) {
      onFetchTokens();
    }
    // if we trust the sender and the source is our popup
    // get the URL params and redirect to our server to use Passport to auth/login
  };

  const onGoogleFileChanged = (
    data: any,
    google: typeof window.google,
    updateFilePermissionToPublic: (fileId: number) => Promise<any>
  ) => {
    if (data.action !== google.picker.Action.PICKED) {
      return;
    }
    const [doc] = data[google.picker.Response.DOCUMENTS];

    const submitFile = () => {
      let embedUrl = doc[google.picker.Document.EMBEDDABLE_URL];
      let name = doc[google.picker.Document.NAME];
      onPickFile({ embedUrl, name });
    };

    try {
      updateFilePermissionToPublic(doc.id);
    } catch {
      // nothing to do
    } finally {
      submitFile();
    }
  };

  return (
    <>
      <div className={'flex flex-col space-y-2'}>
        <button
          onClick={() => openNewOauthPopup('/oauth/google-drive', 'google-drive-oauth', receiveMessage)}
          className='flex gap-1 btn-bedrock-secondary w-[12.5rem]'
        >
          <GoogleDriveIntegrationIcon className='w-5 h-5' />
          <span>Connect Google Drive</span>
        </button>
      </div>
      {tokens.length > 0 && (
        <>
          <div className='my-6 h-px bg-bedrock-gray-medium w-full rounded-[100px]' />
          {tokens.map((token) => (
            <GooglePicker
              key={token.id}
              accessToken={token.access_token}
              fetchTokens={onFetchTokens}
              setError={setErrorNotification}
              mimeTypes={null}
              navHidden
              tokenID={token.id}
              onChange={onGoogleFileChanged}
            >
              <button type='button' className='flex items-center btn-bedrock-secondary px-4 py-[9px] space-x-1'>
                <div className='text-bedrock-p-strong'>{token.email}</div>
              </button>
            </GooglePicker>
          ))}
        </>
      )}
    </>
  );
};
